/**
 * Serializes JSON-compatible data with stable object-key ordering.
 *
 * Runtime instruction formatting and application-layer idempotency both rely
 * on the same canonical representation so equivalent structured input cannot
 * produce different digests because of property insertion order.
 */
export function canonicalJson(value: unknown): string {
	if (Array.isArray(value)) {
		return `[${value.map(canonicalJson).join(",")}]`;
	}
	if (value !== null && typeof value === "object") {
		return `{${Object.entries(value)
			.filter(([, item]) => item !== undefined)
			.sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0))
			.map(([key, item]) => `${JSON.stringify(key)}:${canonicalJson(item)}`)
			.join(",")}}`;
	}

	const serialized = JSON.stringify(value);
	if (serialized === undefined) {
		throw new TypeError("Value is not JSON serializable");
	}
	return serialized;
}
